"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _Button = require("../../EpicEula/components/Button");

var _Button2 = _interopRequireDefault(_Button);

var _components = require("components");

var _SubscriptionSuccessBox = require("./SubscriptionSuccessBox.scss");

var _SubscriptionSuccessBox2 = _interopRequireDefault(_SubscriptionSuccessBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscriptionSuccessBox = function (_React$Component) {
  (0, _inherits3.default)(SubscriptionSuccessBox, _React$Component);

  function SubscriptionSuccessBox() {
    (0, _classCallCheck3.default)(this, SubscriptionSuccessBox);
    return (0, _possibleConstructorReturn3.default)(this, (SubscriptionSuccessBox.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionSuccessBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubscriptionSuccessBox, [{
    key: "render",
    value: function render() {
      var _classnames;

      var title = "Success";
      var megascans = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, _SubscriptionSuccessBox2.default["icon"], true), (0, _defineProperty3.default)(_classnames, _SubscriptionSuccessBox2.default["megascans"], true), _classnames));
      return _react2.default.createElement(
        _components.Popup,
        null,
        _react2.default.createElement(
          "section",
          { className: _SubscriptionSuccessBox2.default.subscriptionSuccessBox },
          _react2.default.createElement(
            _components.Popup.Header,
            null,
            title
          ),
          _react2.default.createElement(
            _components.Popup.Content,
            null,
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "div",
                { className: _SubscriptionSuccessBox2.default.iconContainer },
                _react2.default.createElement("span", { className: megascans }),
                _react2.default.createElement(
                  "span",
                  { className: _SubscriptionSuccessBox2.default.icon },
                  _react2.default.createElement(
                    "svg",
                    {
                      width: "32",
                      height: "32",
                      viewBox: "0 0 32 32",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    },
                    _react2.default.createElement("path", {
                      fillRule: "evenodd",
                      clipRule: "evenodd",
                      d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM20.0925 24.8953C24.005 23.0474 25.2316 19.6345 25.5076 18.3049C24.0772 19.77 22.4944 21.2549 21.43 20.227C21.43 20.227 21.3716 14.7407 21.3716 12.4912C21.3716 9.46606 24.2404 7.21157 24.2404 7.21157C22.6626 7.49252 20.7682 8.05441 18.757 10.0279C18.5755 10.2078 18.4035 10.397 18.2416 10.5948C17.38 9.93496 16.2631 10.1328 16.2631 10.1328C16.8666 10.4642 17.469 11.4297 17.469 12.229V20.0856C17.469 20.0856 16.1533 21.243 15.1394 21.243C14.9108 21.2447 14.6852 21.1917 14.4812 21.0884C14.2773 20.9852 14.101 20.8347 13.9671 20.6494C13.8868 20.5446 13.8203 20.4299 13.7693 20.3082V10.6017C13.4695 10.849 12.4565 11.0528 12.4565 9.37109C12.4565 8.32645 13.2094 7.08099 14.5498 6.3173C12.7091 6.59798 10.9851 7.39323 9.57686 8.61135C8.50692 9.53597 7.65118 10.6825 7.06915 11.9713C6.48712 13.2601 6.19275 14.6602 6.20652 16.0742C6.20652 16.0742 7.18685 13.0115 8.4145 12.7286C8.59337 12.6815 8.78077 12.6768 8.96176 12.715C9.14274 12.7531 9.31231 12.833 9.45693 12.9484C9.60155 13.0637 9.71723 13.2112 9.79473 13.3791C9.87223 13.5471 9.90941 13.7308 9.90331 13.9157V21.1075C9.90331 21.8365 9.43342 21.9958 8.99915 21.9879C8.70495 21.9672 8.41414 21.9124 8.13257 21.8247C9.02905 23.038 10.194 24.0276 11.5363 24.7161C12.8786 25.4046 14.362 25.7733 15.8704 25.7935L18.5216 23.1285L20.0925 24.8953Z",
                      fill: "white"
                    })
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                null,
                "We\u2019ve set you up with unlimited access. Your Megascans access is licensed for use with Unreal Engine only."
              )
            )
          ),
          _react2.default.createElement(
            _components.Popup.Footer,
            null,
            _react2.default.createElement(
              "div",
              { className: _SubscriptionSuccessBox2.default.container },
              _react2.default.createElement(_Button2.default, {
                to: "/megascans/library/latest",
                small: true,
                smallSize: true,
                fullWidth: true,
                primary: true,
                label: "Get Started"
              })
            )
          )
        )
      );
    }
  }]);
  return SubscriptionSuccessBox;
}(_react2.default.Component);

exports.default = SubscriptionSuccessBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SubscriptionSuccessBox.jsx
// module id = 2948
// module chunks = 0